import React from 'react';
import { Button } from 'antd';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { colors, dimensions, typography } from '../../../theme';

type ExpandButtonProps = {
  expanded: boolean;
  onClick: () => void;
};

export const ExpandButton: React.FC<ExpandButtonProps> = ({ expanded, onClick }) => (
  <Button
    type='text'
    onClick={onClick}
    icon={expanded ? <ChevronDown size={dimensions.size.iconXs} /> : <ChevronUp size={dimensions.size.iconXs} />}
    iconPosition='end'
    style={{
      height: 30,
      backgroundColor: colors.accentMuted,
      color: colors.accent,
      fontFamily: typography.fontFamily.ui,
      fontSize: typography.fontSize.sm,
      fontWeight: typography.fontWeight.semibold,
      letterSpacing: typography.letterSpacing.wider,
      textTransform: 'uppercase'
    }}
  >
    {expanded ? 'Minimize' : 'Expand'}
  </Button>
);
